import React from 'react';
import PropTypes from 'prop-types';
import Translations from '../../../translation/translation';

function MissingPostcode({ onClick }) {
    return (
        <div className="statusbar-mobile__missing-status statusbar-mobile__missing-status--postcode">
            <Translations translationKey="catalog-missing-status-speed-load-index-hint" />
            {' '}
            <Translations
                translationKey="catalog-statusbar-mobile-missing-status-postcode"
                className="statusbar-mobile__missing-status-action-text"
                onClick={onClick}
            />
        </div>
    );
}

MissingPostcode.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export { MissingPostcode };
